import DashboardLayout from "@/layouts/DashboardLayout/DashboardLayout";

export interface DashboardLayoutWrapperProps {
  children: React.ReactNode;
}

const DashboardLayoutWrapper = ({ children }: DashboardLayoutWrapperProps) => {
  return <DashboardLayout>{children}</DashboardLayout>;
};

export default DashboardLayoutWrapper;
